import { render, staticRenderFns } from "./YouMayAlsoLike.vue?vue&type=template&id=479ed7f4&scoped=true&"
import script from "./YouMayAlsoLike.vue?vue&type=script&lang=js&"
export * from "./YouMayAlsoLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ed7f4",
  null
  
)

export default component.exports